module.exports = __webpack_public_path__ + "static/media/pencil-edit-button-white.a264a8aa.png";